const LOCALE_BY_CURRENCY = {
    BRL: 'pt-BR',
    USD: 'en-US',
    CAD: 'en-CA',
    EUR: 'es-ES',
    GBP: 'en-GB',
    ARS: 'es-AR',
    UYU: 'es-UY',
    PYG: 'es-PY',
    CLP: 'es-CL',
    COP: 'es-CO',
    PEN: 'es-PE',
    MXN: 'es-MX',
};

function resolveLocale(currency, locale) {
    if (locale) {
        return locale;
    }
    return LOCALE_BY_CURRENCY[currency] || 'pt-BR';
}

export function formatCurrency(value, currency = 'BRL', locale = null) {
    const safeCurrency = currency || 'BRL';
    const resolvedLocale = resolveLocale(safeCurrency, locale);
    return new Intl.NumberFormat(resolvedLocale, {
        style: 'currency',
        currency: safeCurrency,
    }).format(parseFloat(value) || 0);
}

export function getCurrencySymbol(currency = 'BRL', locale = null) {
    const safeCurrency = currency || 'BRL';
    const resolvedLocale = resolveLocale(safeCurrency, locale);
    try {
        const parts = new Intl.NumberFormat(resolvedLocale, {
            style: 'currency',
            currency: safeCurrency,
        }).formatToParts(0);
        const symbolPart = parts.find((part) => part.type === 'currency');
        return symbolPart ? symbolPart.value : safeCurrency;
    } catch (e) {
        return safeCurrency;
    }
}
